import React, { useEffect, useMemo, useState } from "react";
import { Modal, Spinner, Form, Row, Col, Button, Table } from "react-bootstrap";
import {
  HiOutlineArrowLeft,
  HiOutlineUser,
  HiOutlineEnvelope,
  HiOutlinePhone,
  HiOutlineCalendarDays,
  HiOutlineIdentification,
  HiOutlinePencilSquare,
  HiOutlineBriefcase,
  HiOutlineAcademicCap,
  HiOutlineHeart,
  HiOutlineHome,
  HiOutlineMapPin,
  HiOutlineUsers,
  HiOutlineUserGroup,
  HiOutlineQrCode,
  HiOutlineChartBar,
} from "react-icons/hi2";
import AdminTemplate from "../../../components/admin/layouts/Template";
import ContentWrapper from "../../../components/common/ContentWrapper";
import { history } from "../../../helper/history";
import { routes } from "../../../helper/routes";
import { StudentService } from "../../../service/manage/registration/student.service";
import { TeacherService } from "../../../service/manage/registration/teacher.service";
import { AdminService } from "../../../service/manage/registration/admin.service";
import { ParentDashboardService } from "../../../service/manage/dashboard/parent_dashboard.service";
import { GenderService } from "../../../service/settings/manage/gender.service";
import { StatusService } from "../../../service/settings/manage/status.service";
import { assessmentService } from "../../../service/assessment/assessmentService";
import { GradeService } from "../../../service/settings/manage/grade.service";
import { StatusTypesService } from "../../../service/settings/manage/status_type.service";
import { StudentAddressService } from "../../../service/manage/registration/student_address.service";
import { ManageDashboardService } from "../../../service/manage/dashboard/manage_dashboard.service";
import { CountryService } from "../../../service/settings/manage/country.service";
import { ProvinceService } from "../../../service/settings/manage/province.service";
import { CityService } from "../../../service/settings/manage/city.service";
import { StaffService } from "../../../service/user_management/staff.service";
import { roleService } from "../../../service/user_management/role.service";
import { UserManagementService } from "../../../service/user_management/user_management.service";
import { roleTypeConstants } from "../../../helper/constants";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import QRgenerator from "../attendance/QRgenerator.js";
import ProgressBarChart from "../charts/ProgressBarChart.js";
import Enrollment_accordion from "../dashboard/edsider/Enrollment_accordion.js";
import "./DetailedProfile.css";

const PERMANENT_ADDRESS_TYPE_ID = 1;
const BILLING_ADDRESS_TYPE_ID = 2;
const SHIPPING_ADDRESS_TYPE_ID = 3;

const ADDRESS_TYPES = [
  { key: "permanent", type_id: PERMANENT_ADDRESS_TYPE_ID, label: "Permanent Address" },
  { key: "billing", type_id: BILLING_ADDRESS_TYPE_ID, label: "Billing Address" },
  { key: "shipping", type_id: SHIPPING_ADDRESS_TYPE_ID, label: "Shipping Address" },
];

const getDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  return value;
};

const formatDate = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return getDisplayValue(value);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const extractList = (response, keys = []) => {
  const payload = response?.data ?? response;
  if (Array.isArray(payload)) return payload;
  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const buildStatChartArray = (dashboardData) => {
  if (!Array.isArray(dashboardData)) return [];
  const groupedData = dashboardData.reduce((acc, obj) => {
    const key = `${obj.chart_type}_${obj.chart_id}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
  const arrays = Object.values(groupedData);
  const objectArray = arrays.map((arr) => {
    const highestDisplayOrderObject = arr.reduce((maxObj, obj) => {
      if (!maxObj || obj.display_order > maxObj.display_order) {
        return obj;
      } else {
        return maxObj;
      }
    }, null);
    return {
      array: arr,
      chart_title: arr[0].chart_title,
      chart_type: arr[0].chart_type,
      chart_id: arr[0].chart_id,
      display_order: highestDisplayOrderObject.display_order,
    };
  });
  objectArray.sort((a, b) => a.display_order - b.display_order);
  return objectArray;
};

const DetailedProfile = (props) => {
  const passedEmployee = props.location?.state?.employee || props.location?.state?.teacher;
  const passedAdmin = props.location?.state?.admin;
  const passedParent = props.location?.state?.parent;
  const passedStudent = props.location?.state?.student || passedEmployee || passedAdmin || passedParent;
  const passedManageState = props.location?.state?.manageState || {};
  const passedActiveTab = props.location?.state?.activeTab;

  const isEmployee = Boolean(props.location?.state?.isEmployee);
  const isParent   = Boolean(props.location?.state?.isParent);
  const isAdmin    = Boolean(props.location?.state?.isAdmin);
  const isStudent  = !isEmployee && !isParent && !isAdmin;

  const [activeTab, setActiveTab] = useState(passedActiveTab || "basic");
  const [loading, setLoading] = useState(true);
  const [parentDetails, setParentDetails] = useState([]);

  const userType = isEmployee ? "teacher" : isAdmin ? "admin" : isParent ? "parent" : (passedStudent ? "student" : (sessionStorage.getItem("userType") || "student"));
  const email = passedStudent?.email || sessionStorage.getItem("email");
  const userId = passedStudent?.stu_id || passedStudent?.user_id || passedStudent?.id || sessionStorage.getItem("manage_user_id");

  const [userData, setUserData] = useState(passedStudent || null);
  const [formData, setFormData] = useState({
    first_name: passedStudent?.first_name || "",
    last_name: passedStudent?.last_name || "",
    phone_number: passedStudent?.phone_number || "",
    dob: passedStudent?.dob ? passedStudent.dob.split("T")[0] : "",
    idValue: passedStudent?.idValue || "",
    grade: passedStudent?.grade || "",
    medium: passedStudent?.medium || "",
    school: passedStudent?.school || "",
    gender_id: passedStudent?.gender_id || "",
    email: passedStudent?.email || email || "",
    user_code: passedStudent?.user_code || "",
    user_status_id: passedStudent?.status || passedStudent?.user_status_id || "",
  });

  const [genderOptions, setGenderOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [mediumOptions, setMediumOptions] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [addressData, setAddressData] = useState({ permanent: null, billing: null, shipping: null });
  const [showQrModal, setShowQrModal] = useState(false);

  // Assign Role modal state
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [assignedRoles, setAssignedRoles] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [selectedRoleCode, setSelectedRoleCode] = useState("");
  const [isRoleModalLoading, setIsRoleModalLoading] = useState(false);
  const [isRoleSubmitting, setIsRoleSubmitting] = useState(false);
  const mainTableId = props.location?.state?.manageState?.main_table_id ||
    props.location?.state?.main_table_id ||
    props.location?.state?.employee?.main_table_id ||
    10;

  // Statistics State
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsData, setStatsData] = useState({
    dashboardData: [],
    suitableArray: [],
    statsArray: [],
    packageArray: [],
    subjectsAvailable: null,
    enrolledPapers: null,
    completedPapers: null,
  });

  const getChildDashboardStats = async (studentObj) => {
    if (!isStudent) return;
    const sId = studentObj?.stu_id || studentObj?.user_id || studentObj?.id || userId;
    const tLogId = studentObj?.user_table_id || studentObj?.user_list_table_id || sessionStorage.getItem("table_log_id");

    if (!sId) return;

    setStatsLoading(true);
    try {
      const res = await ManageDashboardService.getStatistics(
        100,
        sId,
        tLogId,
        "viewall",
        "EdSider-student"
      );
      if (res?.data) {
        const suitableArray = buildStatChartArray(res.data);
        const statsArray = suitableArray.filter((item) => item.chart_type.includes("Statistics"));
        const packageArray = suitableArray.filter((item) => item.chart_type.includes("edstu-subscription"));
        const subjectsAvailable = suitableArray.find((item) => item.chart_type.includes("edstu-sub-avail"));
        const enrolledPapers = suitableArray.find((item) => item.chart_type.includes("edstu-enr-paper"));
        const completedPapers = suitableArray.find((item) => item.chart_type.includes("edstu-comp-paper"));

        setStatsData({
          dashboardData: res.data,
          suitableArray,
          statsArray,
          packageArray,
          subjectsAvailable,
          enrolledPapers,
          completedPapers,
        });
      }
    } catch (error) {
      console.warn("Error loading student statistics:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    if (isStudent && activeTab === "stats" && (userData || passedStudent)) {
      getChildDashboardStats(userData || passedStudent);
    }
  }, [activeTab, userData, passedStudent, isStudent]);

  useEffect(() => {
    let isMounted = true;

    const loadProfileData = async () => {
      setLoading(true);
      try {
        let currentStudentData = passedStudent;

        if (!currentStudentData && email) {
          let res;
          if (userType === "teacher") {
            res = await TeacherService.getByEmail(email);
          } else if (userType === "admin") {
            res = await AdminService.getByEmail(email);
          } else {
            res = await StudentService.getStudentbyEmail(email);
          }
          if (res?.success && res?.data) {
            currentStudentData = res.data;
          }
        }

        if (isMounted && currentStudentData) {
          setUserData(currentStudentData);
          setFormData({
            first_name: currentStudentData.first_name || "",
            last_name: currentStudentData.last_name || "",
            phone_number: currentStudentData.phone_number || "",
            dob: currentStudentData.dob ? currentStudentData.dob.split("T")[0] : "",
            idValue: currentStudentData.idValue || "",
            grade: currentStudentData.grade || "",
            medium: currentStudentData.medium || "",
            school: currentStudentData.school || "",
            gender_id: currentStudentData.gender_id || "",
            email: currentStudentData.email || email || "",
            user_code: currentStudentData.user_code || "",
            user_status_id: currentStudentData.status || currentStudentData.user_status_id || "",
          });
        }

        // Fetch Dropdown options
        const languageResult = await assessmentService.getAssessmentLanguage();
        if (isMounted && languageResult?.success && languageResult?.data?.languages) {
          setMediumOptions(languageResult.data.languages.map(lang => ({
            value: lang.language_id,
            label: lang.language,
          })));
        }

        const gradeResult = await GradeService.getGrades();
        if (isMounted && gradeResult?.success && gradeResult?.data) {
          setGradeOptions(gradeResult.data.map(g => ({
            value: g.grade_id,
            label: String(g.grade),
          })));
        }

        const statusTypesResult = await StatusTypesService.getAll();
        const availabilityType = statusTypesResult?.data?.find(t => t.name === "Availability");
        const statusTypeId = availabilityType ? availabilityType.type_id : "";

        const promises = [
          GenderService.getAllGenders(),
          StatusService.getByTypeId(statusTypeId)
        ];

        if (userId && isStudent) {
          promises.push(ParentDashboardService.getAllParents(userId));
          promises.push(StudentAddressService.getStudentAddressById(userId));
        }

        const results = await Promise.all(promises);

        if (isMounted) {
          if (results[0]?.success && results[0]?.data) {
            setGenderOptions(results[0].data.map(g => ({
              value: g.gender_id || g.id,
              label: (g.name || g.gender_name || "").trim()
            })));
          }
          if (results[1]?.success && results[1]?.data) {
            setStatusOptions(results[1].data.map(s => ({
              value: s.status_id || s.id,
              label: s.name || s.status_name
            })));
          }
          if (isStudent) {
            if (results[2]) {
              setParentDetails(extractList(results[2], ["parents"]));
            }
            if (results[3]?.success && results[3]?.data) {
              const newAddressData = { permanent: null, billing: null, shipping: null };
              for (const { key, type_id } of ADDRESS_TYPES) {
                const addr = results[3].data.find((a) => a.student_address_type_id === type_id);
                if (addr) newAddressData[key] = addr;
              }
              setAddressData(newAddressData);
            }
          }
        }
      } catch (err) {
        console.warn("Could not fetch detailed profile info:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadProfileData();

    return () => {
      isMounted = false;
    };
  }, [email, userId, passedStudent, userType, isEmployee, isStudent]);

  const fullName = useMemo(() => {
    const name = `${formData.first_name} ${formData.last_name}`.trim();
    return name || (isEmployee ? "Employee Profile" : "Student Profile");
  }, [formData.first_name, formData.last_name, isEmployee]);

  const initials = useMemo(() => {
    const names = fullName.split(" ").filter(Boolean);
    return names.slice(0, 2).map((n) => n[0]?.toUpperCase() || "").join("") || "E";
  }, [fullName]);

  const getGenderLabel = (id) => {
    const found = genderOptions.find(g => String(g.value) === String(id));
    return found ? found.label : getDisplayValue(id);
  };

  const getGradeLabel = (id) => {
    const found = gradeOptions.find(g => String(g.value) === String(id));
    return found ? found.label : getDisplayValue(id);
  };

  const getMediumLabel = (id) => {
    const found = mediumOptions.find(m => String(m.value) === String(id));
    return found ? found.label : getDisplayValue(id);
  };

  const getStatusLabel = (id) => {
    const found = statusOptions.find(s => String(s.value) === String(id));
    return found ? found.label : getDisplayValue(id);
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      history.goBack();
    } else {
      if (isEmployee) history.push(routes.manage_teacher);
      else if (isParent) history.push(routes.manage_parent);
      else if (isAdmin) history.push(routes.manage_admin);
      else history.push(routes.manage_student);
    }
  };

  const handleEditProfileClick = () => {
    if (!userData) return;

    if (isEmployee) {
      history.push(routes.manage_teacher, {
        ...passedManageState,
        employee: userData,
        teacher: userData,
        openUpdateTeacherModal: true,
      });
    } else if (isParent) {
      history.push(routes.manage_parent, {
        ...passedManageState,
        parent: userData,
        student: userData,
        openUpdateParentModal: true,
      });
    } else if (isAdmin) {
      history.push(routes.manage_admin, {
        ...passedManageState,
        admin: userData,
        openUpdateAdminModal: true,
      });
    } else {
      history.push(routes.manage_student, {
        ...passedManageState,
        student: userData,
        openUpdateStudentModal: true,
      });
    }
  };

  const handleRoleClick = async () => {
    if (!userData) return;

    setShowRoleModal(true);
    setIsRoleModalLoading(true);
    setAssignedRoles([]);
    setSelectedRoleCode("");

    try {
      const userId = userData.user_id || userData.id;
      const [rolesRes, staffRes] = await Promise.all([
        roleService.getRolesForType({ role_user_type_id: roleTypeConstants.EMPLOYEE.id }),
        StaffService.searchStaffByTableAndUserIds(userId, mainTableId),
      ]);
      if (rolesRes?.data) setEmployeeTypes(rolesRes.data);
      if (staffRes?.data) {
        setAssignedRoles(staffRes.data);
        setSelectedRoleCode(staffRes.data[1]?.role_code || "");
      }
    } catch (err) {
      console.warn("Error loading role data:", err);
    } finally {
      setIsRoleModalLoading(false);
    }
  };

  const handleRoleUpdate = async () => {
    if (!selectedRoleCode || assignedRoles.length < 2) return;
    const roleEntry = assignedRoles[1];
    setIsRoleSubmitting(true);
    try {
      const matchedRole = employeeTypes.find((r) => r.role_code === selectedRoleCode);
      const employeeUserRoleData = {
        user_role_id: parseInt(roleEntry.user_role_id),
        user_id: roleEntry.user_id,
        module: "Manage " + (matchedRole?.role_code || selectedRoleCode),
        role_code: matchedRole?.role_code || selectedRoleCode,
      };
      const res = await UserManagementService.updateStaffRole(
        employeeUserRoleData,
        userData.user_id || userData.id
      );
      if (!res?.success) {
        sweetStatusAlert("Failed", res?.message?.error || "Update failed", "error");
      } else {
        // Refresh assigned roles after update
        const userId = userData.user_id || userData.id;
        const refreshed = await StaffService.searchStaffByTableAndUserIds(userId, mainTableId);
        if (refreshed?.data) setAssignedRoles(refreshed.data);
        sweetStatusAlert("Success!", "Role updated successfully!", "success");
      }
    } catch (err) {
      sweetStatusAlert("Failed!", String(err), "error");
    } finally {
      setIsRoleSubmitting(false);
    }
  };

  const handleQrCodeClick = () => {
    setShowQrModal(true);
  };

  if (loading) {
    return (
      <AdminTemplate>
        <ContentWrapper>
          <div className="detailed-profile-wrapper d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        </ContentWrapper>
      </AdminTemplate>
    );
  }

  const tabs = isEmployee || isAdmin || isParent
    ? [
        { key: "basic", label: "Basic details" },
        { key: "profile", label: "Profile Details" },
        { key: "residential", label: "Residential Details" },
      ]
    : [
        { key: "basic", label: "Basic details" },
        { key: "profile", label: "Profile Details" },
        { key: "residential", label: "Residential Details" },
        { key: "parent", label: "Parent Details" },
        { key: "stats", label: "Statistics" },
      ];

  // Dynamic Basic Details Field Grid
  const basicFields = [
    { icon: HiOutlineUser, label: "FIRST NAME", value: getDisplayValue(formData.first_name) },
    { icon: HiOutlineUser, label: "LAST NAME", value: getDisplayValue(formData.last_name) },
    { icon: HiOutlineEnvelope, label: "EMAIL", value: getDisplayValue(formData.email) },
    { icon: HiOutlinePhone, label: "PHONE NUMBER", value: getDisplayValue(formData.phone_number) },
    { icon: HiOutlineCalendarDays, label: "BIRTHDATE", value: formatDate(formData.dob) },
    { icon: HiOutlineIdentification, label: "ID VALUE", value: getDisplayValue(formData.idValue) },
    { icon: HiOutlineBriefcase, label: isEmployee ? "EMPLOYEE ID" : isAdmin ? "ADMIN ID" : isParent ? "PARENT ID" : "STUDENT ID", value: getDisplayValue(formData.user_code) },
  ];

  // Dynamic Profile Details Field Grid
  const profileFields = (isEmployee || isAdmin || isParent)
    ? [
        { icon: HiOutlineUser, label: "GENDER", value: getGenderLabel(formData.gender_id) },
        { icon: HiOutlineHeart, label: "ACTIVE STATUS", value: getStatusLabel(formData.user_status_id) },
        { icon: HiOutlineCalendarDays, label: "CREATED DATE", value: formatDate(userData?.created_on || userData?.created_at) },
      ]
    : [
        { icon: HiOutlineUser, label: "GENDER", value: getGenderLabel(formData.gender_id) },
        { icon: HiOutlineHeart, label: "ACTIVE STATUS", value: getStatusLabel(formData.user_status_id) },
        { icon: HiOutlineBriefcase, label: "SCHOOL", value: getDisplayValue(formData.school) },
        { icon: HiOutlineAcademicCap, label: "GRADE", value: getGradeLabel(formData.grade) },
        { icon: HiOutlineBriefcase, label: "MEDIUM", value: getMediumLabel(formData.medium) },
        { icon: HiOutlineCalendarDays, label: "CREATED DATE", value: formatDate(userData?.created_on || userData?.created_at) },
      ];

  // Dynamic Residential Details Field Grid
  const permanentAddr = addressData.permanent || userData;
  const residentialFields = [
    { icon: HiOutlineHome, label: "ADDRESS LINE 1", value: getDisplayValue(permanentAddr?.address_1) },
    { icon: HiOutlineHome, label: "ADDRESS LINE 2", value: getDisplayValue(permanentAddr?.address_2) },
    { icon: HiOutlineMapPin, label: "COUNTRY", value: getDisplayValue(permanentAddr?.country_name || permanentAddr?.country_id) },
    { icon: HiOutlineMapPin, label: "PROVINCE", value: getDisplayValue(permanentAddr?.province_name || permanentAddr?.province_id) },
    { icon: HiOutlineMapPin, label: "CITY", value: getDisplayValue(permanentAddr?.city_name || permanentAddr?.city_id) },
    { icon: HiOutlineMapPin, label: "POSTAL CODE", value: getDisplayValue(permanentAddr?.postalcode) },
  ];

  // Dynamic Parent Details Field Grid
  const parentObj = parentDetails.length > 0 ? parentDetails[0] : null;
  const parentFields = [
    { icon: HiOutlineUsers, label: "PARENT NAME", value: parentObj ? `${parentObj.first_name || ""} ${parentObj.last_name || ""}`.trim() : "N/A" },
    { icon: HiOutlinePhone, label: "PHONE NUMBER", value: getDisplayValue(parentObj?.phone_number) },
    { icon: HiOutlineEnvelope, label: "EMAIL", value: getDisplayValue(parentObj?.email) },
  ];

  return (
    <AdminTemplate>
      <ContentWrapper>
        <div className="detailed-profile-wrapper">
          {/* Header */}
          <div className="detailed-header">
            <button className="detailed-back-btn" onClick={handleBack} title="Back">
              <HiOutlineArrowLeft size={18} />
            </button>
            <div>
              <h1 className="detailed-header-title">Profile details</h1>
              <p className="detailed-header-subtitle">
                Keep profile details up to date.
              </p>
            </div>
          </div>

          {/* Top Summary Card */}
          <div className="detailed-top-card">
            {/* Left User Panel */}
            <div className="detailed-user-panel">
              <div className="detailed-avatar-circle">{initials}</div>
            </div>

            {/* Right Placeholder Card */}
            <div className="detailed-right-placeholder">
              <div className="detailed-placeholder-content">
                <h2 className="detailed-user-name">{fullName}</h2>
                <div className="detailed-user-role">
                  {isEmployee ? "Employee" : isAdmin ? "Admin" : isParent ? "Parent" : "Student"}
                </div>
                <div className="detailed-email-pill">
                  <div className="detailed-email-icon">
                    <HiOutlineEnvelope />
                  </div>
                  <span className="detailed-email-text">{getDisplayValue(formData.email)}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Tabs Bar */}
          <div className="detailed-tabs-container">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`detailed-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Action Bar */}
          <div className="detailed-action-bar">
            {isEmployee && (
              <button className="detailed-role-btn" type="button" onClick={handleRoleClick}>
                <HiOutlineUserGroup size={16} />
                <span>Role</span>
              </button>
            )}
            {isStudent && (
              <button className="detailed-qr-btn" type="button" onClick={handleQrCodeClick}>
                <HiOutlineQrCode size={16} />
                <span>QR Code</span>
              </button>
            )}
            <button className="detailed-edit-btn" type="button" onClick={handleEditProfileClick}>
              <HiOutlinePencilSquare size={16} />
              <span>Edit Profile</span>
            </button>
          </div>

          <Modal show={showQrModal} onHide={() => setShowQrModal(false)} centered size="sm">
            <Modal.Header closeButton>
              <Modal.Title>QR Code</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="detailed-qr-modal-content">
                {userData ? (
                  <QRgenerator data={userData} />
                ) : (
                  <div className="detailed-qr-modal-empty">No student data available.</div>
                )}
              </div>
            </Modal.Body>
          </Modal>

          {/* Assign Role Modal (Employee only) */}
          <Modal
            size="lg"
            centered
            show={showRoleModal}
            onHide={() => setShowRoleModal(false)}
            aria-labelledby="assign-role-modal-title"
          >
            <Modal.Header closeButton>
              <Modal.Title id="assign-role-modal-title">Assign Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isRoleModalLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 120 }}>
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div>
                  <Table>
                    <thead>
                      <tr>
                        <th className="thead">Module</th>
                        <th className="thead">Role Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedRoles.map((role, index) => (
                        <tr key={index}>
                          <td className="tData">{role.module}</td>
                          <td className="tData">{role.role_code}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
              <Form>
                {!isRoleModalLoading && assignedRoles.length === 2 && (
                  <Row className="my-5">
                    <Form.Group as={Col} md="10" controlId="roleSelectControl">
                      <Form.Label>Role*</Form.Label>
                      <Form.Select
                        aria-label="Select Role"
                        name="role_code"
                        value={selectedRoleCode}
                        onChange={(e) => setSelectedRoleCode(e.target.value)}
                      >
                        <option value="">Select</option>
                        {employeeTypes.map((role) => (
                          <option value={role.role_code} key={role.role_code}>
                            {role.role_code}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    <div className="d-flex align-items-end">
                      <Button
                        variant="primary"
                        onClick={handleRoleUpdate}
                        disabled={isRoleSubmitting}
                      >
                        {isRoleSubmitting ? "Updating..." : "Update"}
                      </Button>
                    </div>
                  </Row>
                )}
                <Modal.Footer>
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowRoleModal(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Tab 1: Basic Details */}
          {activeTab === "basic" && (
            <div className="detailed-section-card">
              <div className="detailed-section-header">
                <div className="detailed-section-badge">
                  <HiOutlineUser />
                </div>
                <h3 className="detailed-section-title">Basic Details</h3>
              </div>
              <div className="detailed-info-grid">
                {basicFields.map((field, idx) => {
                  const Icon = field.icon;
                  return (
                    <div className="detailed-field-card" key={idx}>
                      <div className="detailed-field-icon">
                        <Icon />
                      </div>
                      <div className="detailed-field-content">
                        <span className="detailed-field-label">{field.label}</span>
                        <span className="detailed-field-value">{field.value}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Tab 2: Profile Details */}
          {activeTab === "profile" && (
            <div className="detailed-section-card">
              <div className="detailed-section-header">
                <div className="detailed-section-badge">
                  <HiOutlineBriefcase />
                </div>
                <h3 className="detailed-section-title">Profile Details</h3>
              </div>
              <div className="detailed-info-grid">
                {profileFields.map((field, idx) => {
                  const Icon = field.icon;
                  return (
                    <div className="detailed-field-card" key={idx}>
                      <div className="detailed-field-icon">
                        <Icon />
                      </div>
                      <div className="detailed-field-content">
                        <span className="detailed-field-label">{field.label}</span>
                        <span className="detailed-field-value">{field.value}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Tab 3: Residential Details */}
          {activeTab === "residential" && (
            <div className="detailed-section-card">
              <div className="detailed-section-header">
                <div className="detailed-section-badge">
                  <HiOutlineHome />
                </div>
                <h3 className="detailed-section-title">Residential Details</h3>
              </div>
              <div className="detailed-info-grid">
                {residentialFields.map((field, idx) => {
                  const Icon = field.icon;
                  return (
                    <div className="detailed-field-card" key={idx}>
                      <div className="detailed-field-icon">
                        <Icon />
                      </div>
                      <div className="detailed-field-content">
                        <span className="detailed-field-label">{field.label}</span>
                        <span className="detailed-field-value">{field.value}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Tab 4: Parent Details (Student Only) */}
          {isStudent && activeTab === "parent" && (
            <div className="detailed-section-card">
              <div className="detailed-section-header">
                <div className="detailed-section-badge">
                  <HiOutlineUsers />
                </div>
                <h3 className="detailed-section-title">Parent Details</h3>
              </div>
              <div className="detailed-info-grid">
                {parentFields.map((field, idx) => {
                  const Icon = field.icon;
                  return (
                    <div className="detailed-field-card" key={idx}>
                      <div className="detailed-field-icon">
                        <Icon />
                      </div>
                      <div className="detailed-field-content">
                        <span className="detailed-field-label">{field.label}</span>
                        <span className="detailed-field-value">{field.value}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Tab 5: Statistics (Student Only) */}
          {isStudent && activeTab === "stats" && (
            <div className="detailed-section-card">
              <div className="detailed-section-header">
                <div className="detailed-section-badge">
                  <HiOutlineChartBar />
                </div>
                <h3 className="detailed-section-title">Student Statistics</h3>
              </div>

              {statsLoading ? (
                <div className="detailed-stats-loading">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading Statistics...</span>
                  </Spinner>
                </div>
              ) : (
                <div className="detailed-stats-grid">
                  {/* Left Column: Subjects & Accordions */}
                  <div className="detailed-stats-col">
                    <div className="detailed-stats-subcard">
                      <h4 className="detailed-stats-subtitle">
                        {statsData.subjectsAvailable?.chart_title || "Available Subjects"}
                      </h4>
                      <div className="detailed-subjects-list">
                        {statsData.subjectsAvailable?.array?.length ? (
                          statsData.subjectsAvailable.array.map((sub, i) => (
                            <span className="detailed-subject-badge" key={i}>
                              ● {sub?.chart_x_value}
                            </span>
                          ))
                        ) : (
                          <div className="detailed-empty-text">No Subjects Available</div>
                        )}
                      </div>
                    </div>

                    <div className="detailed-stats-accordion-wrap">
                      <Enrollment_accordion requiredPapers={statsData.enrolledPapers} />
                    </div>
                    <div className="detailed-stats-accordion-wrap">
                      <Enrollment_accordion requiredPapers={statsData.completedPapers} />
                    </div>
                  </div>

                  {/* Right Column: Subscription Packages */}
                  <div className="detailed-stats-col">
                    <div className="detailed-stats-subcard">
                      <h4 className="detailed-stats-subtitle">Subscription Packages</h4>
                      {statsData.packageArray?.slice(0, 3)?.map((packageDetail, idx) => (
                        <div className="detailed-package-card" key={idx}>
                          {packageDetail?.chart_title && (
                            <ProgressBarChart packageDetail={packageDetail} />
                          )}
                        </div>
                      ))}
                      {(!statsData.packageArray || statsData.packageArray.length === 0) && (
                        <div className="detailed-empty-text">No Subscription Packages</div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </ContentWrapper>
    </AdminTemplate>
  );
};

export default DetailedProfile;
